import http from '@/http';
import { BaseService } from '../services/base.service';
import { ClassType } from 'class-transformer/ClassTransformer';

export class ServiceContainer<T extends ClassType<BaseService>> {

	private services: { [key: string]: T };

	constructor() {
		this.services = {};
	}

	set(key: string, service: T) {
		this.services[key] = service;
	}

	get<E>(key: string): E {
		return this.getInstance(key);
	}

	getAll(): { [key: string]: any } {
		const o: { [key: string]: any } = {};
		Object.keys(this.services).forEach(k => {
			Object.defineProperty(o, k, {
				enumerable: true,
				get: () => this.getInstance(k),
			});
		});
		return o;
	}

	private getInstance(key: string): any {
		return new this.services[key](http);
	}
}